import React from "react";
import Select, { components } from "react-select";
import styled from "styled-components";

import { OptionsSelector } from "./OptionsSelector";

// Formats select options to show title and price
const Option = (props) => {
  return (
    <components.Option {...props}>
      {props.data.recommended && (
        <div style={{ fontSize: 12 }}>Recommended Size</div>
      )}
      <span>{props.data.label}</span>
      <span style={{ float: "right" }}>{props.data.price}</span>
    </components.Option>
  );
};

/**
 * Size selector dropdown for products
 * Function found in SizeSelector.js
 *
 * @param {Object}    options          Options to load into select
 * @param {Object}    selectedProduct  Current selected product
 * @param {function}  findProduct      Function to find the selected product
 *
 * @returns {Object}
 */
export default function SizeSelectorDropdown({
  options,
  selectedProduct,
  findProduct,
  showCustomSize
}) {
  const selected = options.find(
    (option) => option.value === selectedProduct?.id
  );
  return (
    <>
      {(window.is_ab_custom_pdp) && (
      <SelectContainer>
        <OptionNameContainer>
          <OptionName>Recommended Sizes</OptionName>
        </OptionNameContainer>
        <OptionsSelector
          selected={selected}
          onChange={findProduct}
          options={options}
        />
      </SelectContainer>) || (<SelectContainer>
        <OptionNameContainer>
          <OptionName>Recommended Sizes</OptionName>
        </OptionNameContainer>
        <Select
          onChange={findProduct}
          options={options}
          value={selected}
          components={{ Option }}
        />
      </SelectContainer>)}
    </>
  );
}

const SelectContainer = styled.div`
  text-align: left;
  padding-bottom: 24px;
`;
const OptionName = styled.p`
  margin: 0;
  font-size: ${(window.is_ab_custom_pdp) ? `16px` : `14px`};
  font-family: ${(window.is_ab_custom_pdp) ? 'var(--font-body-family)' : 'Sofia Pro'};
`;
const OptionNameContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-size: 14px;
  padding-bottom: 8px;
`;
